module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/loading.gif")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loadTitle) + "\n\t\t\t\t\t")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-479a1de6"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading.vue
// module id = 450
// module chunks = 1